<template lang='pug'>
div
  el-table(:data='orders', v-loading='orders == null')
    el-table-column(label='Event')
      template(slot-scope='scope')
        div
          router-link(:to="'/user/orders/' + scope.row.id") {{scope.row.request_name}}
        div.secondary
          | {{$formatCents(scope.row.total_cents)}}
          | Order \#{{scope.row.id}}
    el-table-column(label='People')
      template(slot-scope='scope')
        div
          |{{scope.row.request_people}}
    el-table-column(label='Delivery')
      template(slot-scope='scope')
        div
          i.mat-icon.secondary date_range
          |  {{$formatDate(scope.row.delivery_date)}}
        div
          i.mat-icon.secondary access_time
          |  {{ $formatTime(scope.row.delivery_time) }}

    el-table-column(label='Status')
      template(slot-scope='scope')
        status-tag(:status='scope.row.status')
    el-table-column(label='Vendor')
      template(slot-scope='scope')
        div
          |{{scope.row.vendor_name}}
    el-table-column(label='Action')
      template(slot-scope='scope')
        el-button(type='primary' @click='onCloneOrder(scope.row.request_id)')
            | Clone order
        
  el-col()
    el-pagination( 
      v-if="pagination.pages > 1"
      @current-change="onPaginationChange"
      :page-size="pagination.per_page", 
      :pager-count="pagination.pages", 
      layout="prev, pager, next", 
      :total="pagination.total") 
</template>

<script>

  import StatusTag from '../../common/StatusTag.vue'
  import Order from './Order.vue'

  function data(){
    return {
      orders: null,
      displayScheduler: false,
      orderOnSchedule: null,
      pagination: {
        per_page: null,
        current: null,
        pages: null,
        total: null,
      }
    }
  }

  function created(){
    this.getData()
  }

  function onPaginationChange(current_page){
    this.getData(current_page);
  }

  function onCloneOrder(request_id){
    const target = `orders/${request_id}/clone`;
    this.$router.push({path: target})
  }

  function confirmDialog(id){
    const title = "Confirm order"
    const msg = "The customer will be invoiced and charged. Continue?"
    this.$confirm(msg, title, {
      confirmButtonText: 'Confirm & bill order',
      cancelButtonText: 'Cancel',
      type: 'warning'
    }).then(() => {
      this.confirm(id)
    }).catch(() => { })
  }

  function scheduleDialog(order){
    this.orderOnSchedule = order
    this.displayScheduler = true
  }

  function confirm(id){
    const target = `/orders/${id}/confirm`
    this.$simplecater.post(target).then(r => {
      this.$message("The order has been confirmed")
      this.getData()
    }).catch(()=>{
      this.$message.error("Confirmation failed")
    })
  }

  function schedule(id){
    this.$message("PENDING WIRING")
  }

  function goToInvoice(id){
    this.$router.push(`/invoices/${id}`)
  }

  function goToDelivery(id){
    this.$router.push(`/deliveries/${id}`)
  }

  function getData(current_page){
    let reqParams = (current_page ?{params:{ page:current_page}}:{params:{}});
    if(this.sorting){
      this.$isNumber(this.sorting)?reqParams.params.id=this.sorting:reqParams.params.q=this.sorting
    }

    this.$simplecater.get(this.targetUri,reqParams).then((r)=>{
      this.orders = r.data.data;
      this.pagination = r.data.pagination;
    }).catch(()=>{
      this.$message.error('Failed to load data')
    })
  }

  function markCancelledDialog ( id ) {
    const title = "Cancel Order"
    const msg = "The order will be cancelled. Continue?"
    this.$confirm(msg, title, {
      confirmButtonText: 'Yes, cancel order',
      cancelButtonText: 'Cancel',
      confirmButtonClass: 'order-list__red-btn',
      type: 'error'
    }).then(() => {
      this.markCancelled(id)
    }).catch(() => { })
  }

  function markCancelled ( id ) {
    const target = `/orders/${id}/mark_cancelled`
    this.$simplecater.post(target).then(r => {
      this.$message("The order has been cancelled")
      this.getData()
    }).catch(()=>{
      this.$message.error("Cancelling failed")
    })
  }

  const watch = {
    sorting: function(){
      this.getData();
    },
    filter: function(newFilter){
      console.log("FILTER FROM TO", this.filter, newFilter)
    }
  }

  const computed = {
    targetUri: function(){
      if(this.filter == 'all'){
        return '/orders'
      }else{
        return `/orders/${this.filter}`
      }
    }
  }

  const components = {
    StatusTag, Order
  }

  const methods = {
    getData, onCloneOrder, onPaginationChange, confirm, confirmDialog, schedule, scheduleDialog,
    goToInvoice, goToDelivery, markCancelledDialog, markCancelled,
  }

  const props = {
    filter: { required: true },
    sorting:{ required: false }
  }

  export default { methods, components, data, created, watch, props, computed }
</script>

<style lang="sass">
  .order-list__red-btn
    background: red !important
    border-color: red !important
    &:hover
      opacity: 0.6

</style>



// WEBPACK FOOTER //
// src/user/blocks/OrderList.vue